function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 26.9c1.9 0 3.4-1.5 3.4-3.4v-5.6c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v5.6c0 1.9 1.6 3.4 3.4 3.4zm5.6-5.6H30c-.3 0-.6.3-.6.6v1.7c0 2.6-2.3 4.7-4.9 4.5-2.3-.2-4.1-2.3-4.1-4.7v-1.5c0-.3-.3-.6-.6-.6h-.6c-.3 0-.6.3-.6.6v1.4c0 3.2 2.2 6 5.3 6.4v1.2h-2c-.3 0-.6.3-.6.6v.6c0 .3.3.6.6.6h5.6c.3 0 .6-.3.6-.6v-.6c0-.3-.3-.6-.6-.6h-2v-1.2c3-.4 5.3-3 5.3-6.1v-1.7c.3-.4.1-.6-.3-.6z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgMicrophone;